const articles = [
  {
    id: 1,
    title: "Well Known across the globle",
    text: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Delectus, est fugit assumenda consequuntur odio id bland.",
  },
  {
    id: 2,
    title: "Way ahead of competarion",
    text: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum corrupti, id suscipit distinctio earum quisquam!",
  },
  {
    id: 3,
    title: "Our Reviews",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt itaque explicabo, quam cupiditate velit veritatis.",
  },
  {
    id: 4,
    title: "Our Experties",
    text: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt facere ratione architecto maxime vitae dignissimos.",
  },
];

export default articles;
